import { Link, useLocation, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet-async';

const AboutUsScreen = () => {
  return (
    <Container>
      <Helmet>
        <title>About Us</title>
      </Helmet>
      <img className="img-fluid" src="images/food.jpg" />
      <h1 className="my-3">About Us</h1>
      <p>Before we started Project Dream, we were just individuals living our lives, caught up in building our careers and handling our responsibilities at home.

Sure, we’d see on the news or read in the papers about the problems Filipinos faced - the poverty, lack of education, health issues, human trafficking, natural disasters. And while we felt bad about what was happening, we always told ourselves, “Some day, when we’re settled with our lives and we’ve reached our personal goals, we’ll actively do something to help.”

So time passed. Until one day we realized that if we continue to put off helping others because we’re still working hard at creating our own perfect lives, the “perfect time” to help will never arrive.

Hunger can’t wait. Education and health can’t wait. The environment and human trafficking certainly can’t wait. And this is why we finally started Project Dream. Because there is something more urgent out there than our careers and personal goals.

The things we need to accomplish are huge. We can’t do it on our own. Through this website, we work with people from all over the world to slowly build a better life for the Filipinos and a better environment for the Philippines.</p>
    </Container>
  );
}

export default AboutUsScreen;
